// extracted by mini-css-extract-plugin
export default {"videoHeader":"Podcast_videoHeader__1XY6r","video":"Podcast_video__gK4ml"};